import { useState } from "react";
import { instance } from "utils/axios";

const C = { purple: "#7B2FBE", yellow: "#FFD600", border: "#e8e0f5", bg: "#f7f4fc" };

const Btn = ({ onClick, disabled, children, color = C.purple, style = {} }) => (
    <button onClick={onClick} disabled={disabled}
        style={{
            background: color, color: "#fff", border: "none", borderRadius: 50,
            padding: "13px 36px", fontSize: 15, fontWeight: 800, cursor: disabled ? "not-allowed" : "pointer",
            fontFamily: "inherit", opacity: disabled ? 0.6 : 1, transition: "transform 0.15s", ...style
        }}
        onMouseEnter={e => { if (!disabled) e.currentTarget.style.transform = "scale(1.03)"; }}
        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}>
        {children}
    </button>
);

export default function Payment({ applicantAdmissionId, onSuccess, onBack }) {
    const [step, setStep] = useState("terms"); // terms | qpay | success
    const [approved, setApproved] = useState(false);
    const [data, setData] = useState(null);
    const [qpData, setQpData] = useState(null);
    const [guid, setGuid] = useState(null);
    const [loading, setLoading] = useState(false);
    const [checking, setChecking] = useState(false);
    const [checkMsg, setCheckMsg] = useState("");
    const [error, setError] = useState(null);

    const fetchPayment = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await instance.post("applicant2/payment/create", { applicantAdmissionId });
            const d = res.data;
            setData(d);
            setGuid(d.guid);
            const qp = typeof d.qpayData === "string" ? JSON.parse(d.qpayData) : d.qpayData;
            setQpData(qp);
            setStep("qpay");
        } catch {
            setError("Төлбөрийн мэдээлэл авахад алдаа гарлаа. Дахин оролдоно уу.");
        } finally {
            setLoading(false);
        }
    };

    const handleCheck = async () => {
        if (!guid) return;
        setChecking(true);
        setCheckMsg("");
        try {
            const res = await instance.get(`applicant2/payment/check/${guid}`);
            if (res.data?.status === "success" || res.data === "success") {
                setStep("success");
                setTimeout(() => onSuccess(), 1500);
            } else {
                setCheckMsg("Төлөгдөөгүй байна. Дахин оролдоно уу.");
            }
        } catch {
            setCheckMsg("Алдаа гарлаа. Дахин оролдоно уу.");
        } finally {
            setChecking(false);
        }
    };

    // ── TERMS ─────────────────────────────────────────────────────────────────
    if (step === "terms") return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "28px 16px 60px", fontFamily: "'Raleway','Segoe UI',sans-serif" }}>

            <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 2px 20px rgba(0,0,0,0.07)", padding: "28px 32px", marginBottom: 20, borderTop: `4px solid ${C.purple}`, width: "100%", maxWidth: 600, boxSizing: "border-box" }}>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: C.purple, margin: "0 0 16px" }}>Өргөдлийн хураамж</h2>
                <p style={{ fontSize: 14, color: "#333", lineHeight: 1.8, margin: "0 0 14px" }}>
                    Томүжин Алтернатив сургуульд өргөдөл илгээх хураамж нь <strong>60,000 төгрөг</strong> байх ба энэхүү журамтай танилцаж, хүлээн зөвшөөрснөөр интернэт банкаар төлбөр төлөх цонх руу очно.
                </p>
                <ul style={{ paddingLeft: 20, margin: "0 0 16px", color: "#444", fontSize: 14, lineHeight: 2 }}>
                    <li>Энэхүү хураамжийг өргөдөл илгээхийн өмнө бүрэн төлөх шаардлагатай бөгөөд нэгэнт хийгдсэн тохиолдолд буцаан олгогдохгүй.</li>
                    <li>Хураамж төлсөн нь сургуулийн элсэлтийн баталгаа болохгүй бөгөөд бүх өргөдлийг сургуулийн элсэлтийн бодлогын дагуу нягтлан шалгаж, хариуг гаргана.</li>
                    <li>Төлбөр төлсний дараа таны бүртгэл баталгаажиж, 1-р шатны өргөдөл илгээх холбоос таны портал дээр харагдана.</li>
                </ul>
                <p style={{ fontSize: 13, color: "#666", margin: 0 }}>
                    Нэмэлт мэдээлэл авахыг хүсвэл{" "}
                    <a href="mailto:admissions@tomujin.edu.mn" style={{ color: C.purple, fontWeight: 700 }}>admissions@tomujin.edu.mn</a>
                    {" "}хаягаар холбогдоно уу.
                </p>
            </div>

            {/* Checkbox */}
            <label style={{ display: "flex", alignItems: "flex-start", gap: 12, maxWidth: 600, width: "100%", cursor: "pointer", marginBottom: 24, padding: "16px 20px", background: "#fff", borderRadius: 12, border: `1.5px solid ${approved ? C.purple : C.border}`, boxSizing: "border-box", transition: "border 0.2s" }}>
                <div onClick={() => setApproved(!approved)}
                    style={{ width: 20, height: 20, borderRadius: 6, border: `2px solid ${approved ? C.purple : "#ccc"}`, background: approved ? C.purple : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1, transition: "all 0.15s", cursor: "pointer" }}>
                    {approved && <span style={{ color: "#fff", fontSize: 13, fontWeight: 900 }}>✓</span>}
                </div>
                <span style={{ fontSize: 14, color: "#333", lineHeight: 1.6 }}>
                    Би дээрх өргөдлийн хураамжийн нөхцлийг уншиж танилцсан, зөвшөөрч байна.
                </span>
            </label>

            {error && <div style={{ color: "#e53935", fontSize: 13, marginBottom: 12 }}>{error}</div>}

            <div style={{ display: "flex", gap: 12 }}>
                <Btn onClick={onBack} color="#ddd" style={{ color: "#555" }}>← Буцах</Btn>
                <Btn onClick={fetchPayment} disabled={!approved || loading}>
                    {loading ? "Ачаалж байна..." : "Төлбөр төлөх →"}
                </Btn>
            </div>
        </div>
    );

    // ── QPAY ──────────────────────────────────────────────────────────────────
    if (step === "qpay") return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "28px 16px 60px", fontFamily: "'Raleway','Segoe UI',sans-serif" }}>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: C.purple, margin: "0 0 20px" }}>Өргөдлийн хураамж төлөх</h2>

            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center", width: "100%", maxWidth: 780 }}>

                {/* Info card */}
                <div style={{ flex: 1, minWidth: 260, background: "#fff", borderRadius: 16, boxShadow: "0 2px 20px rgba(0,0,0,0.07)", padding: "24px", boxSizing: "border-box" }}>
                    <div style={{ fontSize: 13, color: "#888", marginBottom: 8, fontStyle: "italic", lineHeight: 1.6 }}>
                        Та интернэт банкаа ашиглан төлнө үү. Та төлбөрөө төлснөөр бүртгэл баталгаажих болно.
                    </div>
                    <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 12, marginTop: 4 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: C.purple, marginBottom: 2 }}>Нэр:</div>
                        <div style={{ fontSize: 14, marginBottom: 10 }}>{data?.firstName} {data?.lastName}</div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: C.purple, marginBottom: 2 }}>Регистрийн дугаар:</div>
                        <div style={{ fontSize: 14, marginBottom: 10 }}>{data?.regno}</div>
                        <div style={{ borderTop: `2px solid ${C.purple}`, paddingTop: 10, fontSize: 15, fontWeight: 800, color: C.purple, textAlign: "right" }}>
                            Төлөх дүн: ₮60,000
                        </div>
                    </div>
                </div>

                {/* QR card */}
                <div style={{ flex: 1, minWidth: 260, background: "#fff", borderRadius: 16, boxShadow: "0 2px 20px rgba(0,0,0,0.07)", padding: "24px", boxSizing: "border-box", textAlign: "center" }}>
                    {qpData?.qr_image && (
                        <img src={`data:image/png;base64,${qpData.qr_image}`} alt="QPay QR"
                            style={{ width: 180, height: 180, margin: "0 auto 12px", display: "block", borderRadius: 12 }} />
                    )}

                    {checkMsg && (
                        <div style={{ fontSize: 13, marginBottom: 10, color: checkMsg.includes("Төлөгдсөн") ? "#16a34a" : "#e53935" }}>
                            {checkMsg}
                        </div>
                    )}

                    <Btn onClick={handleCheck} disabled={checking} style={{ width: "100%", borderRadius: 12 }}>
                        {checking ? "Шалгаж байна..." : "✓ Гүйлгээ шалгах"}
                    </Btn>

                    {/* Bank logos — mobile only */}
                    {qpData?.urls?.length > 0 && (
                        <div className="md:hidden" style={{ marginTop: 16 }}>
                            <div style={{ fontSize: 13, fontWeight: 700, color: C.purple, marginBottom: 8 }}>Банкны апп</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
                                {qpData.urls.map((u, i) => (
                                    <div key={i} onClick={() => window.open(u.link)}
                                        style={{ cursor: "pointer", padding: 8, borderRadius: 12, background: C.bg, border: `1px solid ${C.border}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <img src={u.logo} alt={u.name} style={{ height: 44, width: 44, objectFit: "contain", borderRadius: 8 }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <button onClick={() => setStep("terms")}
                style={{ background: "none", border: "none", color: "#888", fontSize: 13, cursor: "pointer", fontFamily: "inherit", marginTop: 20 }}>
                ← Буцах
            </button>
        </div>
    );

    // ── SUCCESS ───────────────────────────────────────────────────────────────
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", padding: "28px 16px", fontFamily: "'Raleway','Segoe UI',sans-serif", textAlign: "center" }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>🎉</div>
            <h2 style={{ fontSize: 22, fontWeight: 800, color: C.purple, margin: "0 0 12px" }}>Төлбөр амжилттай төлөгдлөө!</h2>
            <div style={{ background: "#f0fdf4", borderRadius: 16, padding: "20px 28px", maxWidth: 440, marginBottom: 24, border: "1.5px solid #86efac", lineHeight: 1.8, fontSize: 14, color: "#333" }}>
                Таны өргөдлийн хураамж амжилттай төлөгдөж Томүжин Алтернатив сургуулийн элсэлтийн портал руу нэвтрэх эрх нээгдлээ.<br />
                Портал руу нэвтэрнэ өргөдөл эхлүүлэх боломжтой.<br /><br />
                <strong>Нэвтрэх нэр:</strong> таны имэйл хаяг<br />
                <strong>Нууц үг:</strong> таны утасны дугаар
            </div>
            <Btn onClick={() => window.open("https://portal.tomujin.edu.mn", "_blank")}>
                Портал руу нэвтрэх →
            </Btn>
        </div>
    );
}